angular.module('upDirectives').directive('upEventEmail', function () {
	return {
		restrict: 'A',
		templateUrl: require('App/upsales/common/directives/event/upEventEmail.tpl.html?file'),
		require: 'upEventEmail',
		scope: { event: '=upEventEmail' },
		controller: [function () {}]
	};
});
